module.exports = __webpack_public_path__ + "img/镜柜壁龛.38f050f9.webp";